import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Divider, message } from 'antd'
import { Redirect, Link } from 'react-router-dom'
import { Mutation, ApolloConsumer } from 'react-apollo'
import validator from 'validator'
import {
  H4, P, InputWithLabel, Button, Div, SmallText, Label,
} from 'konsys-ui'
import Container from '../../components/container'
import { theme } from '../../styles/_variables'
import { REGISTER, LOGIN } from '../../constants/graphql/mutation'
import { setAccessToken, setRefreshToken, getAccessToken } from '../../utils/local-data-service'
import history from '../../history'
import URL from '../../constants/environment'

const url = process.env.REACT_APP_BUILD_MODE === 'production' ? URL.production : (process.env.REACT_APP_BUILD_MODE === 'staging') ? URL.staging : URL.development

export const LoginContainer = ({ onSuccess }) => {
  const [disabledButton, setDisabledButton] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [newEmail, setNewEmail] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')

  return (
    <Mutation
      mutation={LOGIN}
    >
    {
      doLogin => (
        <Div>
          <H4 letterSpacing='1px' playfair={true} margin='0 0 48px'>Booking Information</H4>
          <Div display='flex'>
            <P color={theme.color.purplishGrey}>User Account Information</P>
          </Div>
          <Div margin='0 0 32px 0'>
            <SmallText margin='0 8px 0 0'>or</SmallText>
            <a href="#register"><SmallText color={theme.color.secondaryColor} style={{ cursor: 'pointer' }}>Register to use new information</SmallText></a>
          </Div>
          <Div display='flex' flexDirection='column'>
            <InputWithLabel
              margin='8px 0'
              title={{ text: 'Email' }}
              width='100%'
              input={{
                onChange: e => setEmail(e.target.value),
                margin: '-8px 0 0',
              }}
            />
            <InputWithLabel
              margin='8px 0'
              title={{ text: 'Password' }}
              width='100%'
              input={{
                type: 'password',
                onChange: e => setPassword(e.target.value),
                margin: '-8px 0 0',
              }}
            />
            <Link to='/forgot-password' style={{ alignSelf: 'flex-end' }}><P bold color={theme.color.primaryColor}>Forgot password</P></Link>
            <Button
              text='Login'
              inverse
              margin='32px 0 24px'
              disabled={!validator.isEmail(email) || password.length < 8 || disabledButton}
              onClick={() => {
                setDisabledButton(true)
                doLogin({
                  variables: {
                    username: email,
                    password,
                    grant_type: 'password',
                    client_id: url.CLIENT_ID,
                    client_secret: url.CLIENT_SECRET,
                  },
                }).then((resp) => {
                  setDisabledButton(false)
                  if (resp.data.login.success) {
                    setAccessToken(resp.data.login.createdAccessToken.access_token)
                    setRefreshToken(resp.data.login.createdAccessToken.refresh_token)
                    message.success(resp.data.login.message)
                    setTimeout(() => {
                      if (onSuccess) {
                        onSuccess()
                      } else {
                        window.location = `${url.WEB_SERVER}/`
                      }
                    }, 3000)
                  } else message.error(resp.data.login.message)
                })
              }}
            />
          </Div>
          <Divider><P letterSpacing='2px' color={theme.color.purplishGrey}>OR</P></Divider>
          <P color={theme.color.purplishGrey} margin='24px 0 32px 0' id='register'>Use New Information</P>
          <Div display='flex' flexDirection='column'>
            <InputWithLabel margin='8px 0' title={{ text: 'Email *' }} width='100%' input={{ margin: '-8px 0 0', onChange: e => setNewEmail(e.target.value) }}/>
            <InputWithLabel margin='8px 0' title={{ text: 'Password *' }} width='100%' input={{
              margin: '-8px 0 0',
              type: 'password',
              onChange: e => setNewPassword(e.target.value),
              message: 'Please set password length to be at least 8 characters',
            }}/>
            <InputWithLabel margin='8px 0' title={{ text: 'Name *' }} width='100%' input={{ margin: '-8px 0 0', onChange: e => setName(e.target.value) }}/>
            <InputWithLabel margin='8px 0' title={{ text: 'Phone *' }} width='100%' input={{ margin: '-8px 0 0', onChange: e => setPhone(e.target.value) }}/>
            <Mutation
              mutation={REGISTER}
            >{doRegister => (
              <Div>
                <Button
                  text='Create Account'
                  inverse
                  margin='32px 0 0'
                  fullWidth
                  disabled={!validator.isEmail(newEmail) || newPassword.length < 8 || name.length < 1 || phone.length < 9 || disabledButton}
                  onClick={() => {
                    setDisabledButton(true)
                    doRegister({
                      variables: {
                        firstname: name,
                        email: newEmail,
                        phonenumber: phone,
                        password: newPassword,
                        passwordConf: newPassword,
                      },
                    }).then((resp) => {
                      if (resp.data.createUser.success) {
                        setTimeout(() => {
                          if (onSuccess) {
                            doLogin({
                              variables: {
                                username: newEmail,
                                password: newPassword,
                                grant_type: 'password',
                                client_id: url.CLIENT_ID,
                                client_secret: url.CLIENT_SECRET,
                              },
                            }).then((response) => {
                              if (response.data.login.success) {
                                setAccessToken(response.data.login.createdAccessToken.access_token)
                                setRefreshToken(response.data.login.createdAccessToken.refresh_token)
                                message.success(`${response.data.login.message} and ${resp.data.createUser.message}`)
                                setTimeout(() => {
                                  if (onSuccess) {
                                    onSuccess()
                                  } else {
                                    window.location = `${url.WEB_SERVER}/`
                                  }
                                }, 3000)
                              } else {
                                setDisabledButton(false)
                                message.error(resp.data.login.message)
                              }
                            })
                          } else {
                            window.location = `${url.WEB_SERVER}/`
                          }
                        }, 3000)
                      } else {
                        setDisabledButton(false)
                        message.error(resp.data.createUser.message)
                      }
                    })
                  }}
                />
                <Label margin='8px 0 32px' display='block'>* Please fill in all fields</Label>
              </Div>
            )}
            </Mutation>
          </Div>
        </Div>
      )
    }
    </Mutation>
  )
}

export const StepLogin = ({ nextStep, filterData }) => {
  const [mutationSuccess, setMutationSuccess] = useState(null)

  if (mutationSuccess) {
    return (
      <Redirect
        from='/login'
        to={{
          pathname: '/',
          state: nextStep && filterData && {
            filterData,
            step: nextStep,
          },
        }}
      />
    )
  }

  return (
    <LoginContainer onSuccess={() => setMutationSuccess(true)} />
  )
}

export const LoginPage = () => {
  useEffect(() => {
    if (getAccessToken()) {
      history.push('/')
    }
  }, [])

  return (
    <Container>
      <StepLogin />
    </Container>
  )
}

export default LoginPage



// WEBPACK FOOTER //
// ./src/pages/login/index.jsx